import Splide from "@splidejs/splide";

export function slider() {
    document.querySelectorAll(".normalSlider").forEach((root) => {
        let dataAutoplay = root.dataset.autoplay === "true";
        let dataInterval = Number(root.dataset.interval) > 0 ? Number(root.dataset.interval) : 0;

        const splide = new Splide(root, {
            type: "loop",
            perPage: 1,
            focus: "center",
            pagination: true,
            arrows: false,
            classes: {
                pagination:
                    "splide__pagination absolute !p-0 !left-0 !bottom-0 !right-0 flex flex-row [&_li]:h-5 [&_li]:basis-[0%] [&_li]:grow [&_li]:shrink-0 [&_li+li]:ms-2",
                page:
                    "splide__pagination__page !rounded-none !w-full !h-full !transform-none !opacity-100 !m-0 !bg-lightgrey [&.is-active]:!bg-primary",
            },
            mediaQuery: "min",
            autoplay: dataAutoplay,
            interval: dataInterval,
        });

        // sanfte Höhen-Animation
        const track = root.querySelector(".splide__track");
        if (track) track.style.transition = "height .3s ease";

        const updateHeight = () => {
            const slides = splide.Components.Slides;
            const current = slides.getAt(splide.index);
            if (!current) return;

            const slideEl = current.slide;
            const img = slideEl.querySelector("img");
            if (!img) return;

            const apply = () => {
                const width = img.clientWidth || root.clientWidth || 0;
                const h = img.naturalWidth
                    ? Math.round((img.naturalHeight / img.naturalWidth) * width)
                    : Math.round(img.getBoundingClientRect().height);

                const elements = splide.Components.Elements;
                if (h > 0) {
                    elements.track.style.height = h + "px";
                    elements.list.style.height = h + "px";
                    splide.root.style.height = h + "px";
                }
            };

            if (img.complete) apply();
            else img.addEventListener("load", apply, { once: true });
        };

        splide.on("mounted", updateHeight);
        splide.on("moved", updateHeight);
        splide.on("resized", updateHeight);
        splide.on("refresh", updateHeight);

        splide.mount();
    });
}
